<template>
  <div class="component-ranking-top flex-column">
    <div class="ranking-top-header flex-middle">
      <div :style="{ width: number == 1 ? '1.1rem' : '0.85rem', height: number == 1 ? '1.1rem' : '0.85rem' }">
        <img class="top-wr" :src="bg" />
        <img class="top-head" :src="item.avatar" />
      </div>
    </div>
    <div class="flex-middle top-panel focus-panel" :class="'focus-f' + number">
      <template v-if="needFocusBtn">
        <template v-if="!item.isXWYD">
          <div v-if="item.is_follow == 1" class="flex-row align-center focus" :class="'focus-yes-' + number" @click="follow">
            <img :src="focusYesImgArr[number - 1]" />
            <div class="focus-text">已关注</div>
          </div>
          <div v-else class="flex-row align-center focus" :class="'focus-no-' + number" @click="follow">
            <img :src="focusNoImgArr[number - 1]" />
            <div class="focus-text">关注</div>
          </div>
        </template>
      </template>
    </div>
    <div class="flex column justify-center top-panel info-panel" :class="'info-fp' + number">
      <template v-if="!item.isXWYD">
        <div class="flex-row flex-middle">
          <div class="nickname">{{ item.nickname }}</div>
          <img v-if="item.is_live == 1" @click="joinRoom" class="starting" src="./img/starting.gif" />
        </div>
        <div class="flex-row flex-middle">
          <div style="margin-right: 0.08rem">{{ item.stat }}</div>
          <div style="color: #999999">{{ item.stat_label }}</div>
        </div>
        <div class="flex-row justify-center">
          <div class="flex-row flex-middle star">
            <img :src="levelImgArr[item.level]" />
          </div>
          <div class="noble" v-if="item.noble_src">
            <img class="top-tip" :src="item.noble_src" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flex-row flex-middle">
          <div class="nickname" style="color: #bbbbbb; font-weight: 400">{{ item.nickname }}</div>
        </div>
        <div class="flex-row flex-middle">
          <div style="color: #bbbbbb; font-weight: 400">--</div>
        </div>
        <div class="flex-row flex-middle">
          <div style="color: #bbbbbb; font-weight: 400"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
export default {
  props: {
    number: {
      type: Number,
      default: 3,
    },

    header: {
      type: String,
      default: require("./img/head.png"),
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    needFocusBtn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    bg() {
      return this.bgArr[this.number - 1];
    },
    tip() {
      return require("./img/tip-di.png");
    },
  },
  data() {
    return {
      bgArr: [require("./img/t-1.png"), require("./img/t-2.png"), require("./img/t-3.png")],
      focusNoImgArr: [require("./img/focus-no-1.png"), require("./img/focus-no-2.png"), require("./img/focus-no-3.png")],
      focusYesImgArr: [require("./img/focus-yes-1.png"), require("./img/focus-yes-2.png"), require("./img/focus-yes-3.png")],
      levelImgArr: [
        require("./img/lv1.png"),
        require("./img/lv1.png"),
        require("./img/lv2.png"),
        require("./img/lv3.png"),
        require("./img/lv4.png"),
        require("./img/lv5.png"),
        require("./img/lv6.png"),
        require("./img/lv7.png"),
        require("./img/lv8.png"),
        require("./img/lv9.png"),
        require("./img/lv10.png"),
        require("./img/lv11.png"),
        require("./img/lv12.png"),
        require("./img/lv13.png"),
        require("./img/lv14.png"),
        require("./img/lv15.png"),
        require("./img/lv16.png"),
        require("./img/lv17.png"),
        require("./img/lv18.png"),
        require("./img/lv19.png"),
        require("./img/lv20.png"),
        require("./img/lv21.png"),
      ],
    };
  },
  created() {},
  methods: {
    follow() {
      this.$emit("tofollow", this.item);
    },

    joinRoom() {
      if (this.item && this.item.uid) {
        this.$router.push({
          // path: `/liveMatchesTwo/${this.type === "live" ? this.live.anchorid : this.live.id}`,
          path: `/liveMatchesTwo/${this.item.uid}`,
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.component-ranking-top {
  position: relative;
  margin: 0.1rem 0.02rem;
  color: #333333;
  .top-panel {
    padding: 0.1rem 0rem;
    height: 1rem;
  }
  .ranking-top-header {
    position: relative;
    & > div {
      position: relative;
    }
    .top-wr {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      left: 0.05rem;
      top: 0;
    }
    .top-head {
      width: 80%;
      height: 80%;
      border-radius: 0.5rem;
      transform: translateX(-50%);
      overflow: hidden;
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 0.12rem;
    }
    .top-tip {
      position: absolute;
      left: 0.02rem;
      top: 0.02rem;
      width: 0.4rem;
      height: 0.4rem;
      z-index: 3;
    }
  }
  .focus-panel {
    background-position: center bottom;
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 0.45rem;
    &.focus-f1 {
      background-image: url(./img/f-1.png);
    }
    &.focus-f2 {
      background-image: url(./img/f-2.png);
    }
    &.focus-f3 {
      background-image: url(./img/f-3.png);
    }
  }
  .focus {
    border-radius: 0.5rem;
    cursor: pointer;
    height: 0.28rem;
    min-width: 0.72rem;
    //padding-left : .02rem;
    padding-right: 0.08rem;
    flex-wrap: nowrap;
    img {
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.02rem;
      margin-top: 0.025rem;
      margin-left: 0.01rem;
    }
    &.focus-yes-1 {
      color: rgba(255, 136, 0, 0.6);
      border: 1px solid rgba(255, 136, 0, 0.2);
      background: rgba(255, 255, 255, 0.6);
    }
    &.focus-yes-2 {
      color: rgba(164, 176, 186, 0.6);
      border: 1px solid rgba(164, 176, 186, 0.2);
      background: rgba(255, 255, 255, 0.6);
    }
    &.focus-yes-3 {
      color: rgba(194, 120, 66, 0.6);
      border: 1px solid rgba(194, 120, 66, 0.2);
      background: rgba(255, 255, 255, 0.6);
    }
    &.focus-no-1 {
      color: #ffffff;
      background: rgba(255, 136, 0, 0.6);
    }
    &.focus-no-1:hover {
      background: rgba(255, 136, 0, 0.8);
    }
    &.focus-no-2 {
      color: #ffffff;
      background: rgba(164, 176, 186, 0.6);
    }
    &.focus-no-2:hover {
      background: rgba(164, 176, 186, 0.8);
    }
    &.focus-no-3 {
      color: #ffffff;
      background: rgba(194, 120, 66, 0.6);
    }
    &.focus-no-3:hover {
      background: rgba(194, 120, 66, 0.8);
    }
    .focus-text {
    }
  }
  .info-panel {
    background-position: center top;
    background-size: 100% auto;
    background-repeat: no-repeat;
    padding: 0.1rem 0rem;
    & > div {
      padding: 0.04rem 0rem;
    }
    .nickname {
      font-size: 0.18rem;
      white-space: nowrap;
      font-weight: 600;
    }
    &.info-fp1 {
      background-image: url(./img/fp-1.png);
    }
    &.info-fp2 {
      background-image: url(./img/fp-2.png);
    }
    &.info-fp3 {
      background-image: url(./img/fp-3.png);
    }
  }
  .noble {
    margin-left: 0.02rem;
    img {
      height: 0.24rem;
      margin-top: 0.01rem;
    }
  }
  .star {
    margin: 0rem 0.02rem;
    border-radius: 0.3rem;
    color: #ffffff;
    font-size: 0.13rem;
    img {
      height: 0.35rem;
    }
  }
  .starting {
    height: 0.2rem;
  }
}
</style>